import React from 'react';
import { useTranslation } from 'react-i18next';

interface SearchInputProps {
  testId?: string;
  className?: string;
  placeholder?: string;
  text?: string;
  handleChange?: (text: string) => void;
}

export const SearchInput: React.FC<SearchInputProps> = ({
  testId,
  className,
  placeholder,
  text,
  handleChange,
}) => {
  const { t } = useTranslation();
  return (
    <input
      type="text"
      placeholder={t(placeholder ? placeholder : 'common.searchInput', {
        context: 'placeholder',
      })}
      onChange={(e) => handleChange?.(e.target.value)}
      data-testid={testId}
      value={text}
      className={`h-[36px] rounded-[5px] border border-light-6 bg-light-1 px-[15px] placeholder:noto-13-normal placeholder:text-light-5 focus:outline-none ${className}`}
    ></input>
  );
};
